import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Dropdown, Nav } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { Cell, Pie, ResponsiveContainer, PieChart } from 'recharts'
import useLocalStorageState from 'use-local-storage-state'
import { GetRequest } from '../../../Utils/hooks/ApiHandler'
import "./CrmDashboard.css"
export const LeadsBySource = () => {
    const [customer, setCustomer] = useLocalStorageState("customer")
    const navigate = useNavigate();
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication

    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }

    // endpoint stat for leads by source
    const [sourceDuration, setSourceDuration] = useState("all")
    const [leadsSourceData, setLeadSourceData] = useState([])
    const [leadsTotalCount, setLeadsTotalCount] = useState(0)


    // leads by source function handling
    const handleLeadsBySource = async () => {
        try {
            // Validate required data
            if (
                !customer?.customer_details?.customer_id ||
                !customer?.customer_details?.id
            ) {
                console.error("Missing customer details")
                setLeadSourceData([])
                return
            }

            const customerId = customer.customer_details.customer_id
            const id = customer.customer_details.id

            let url
            if (sourceDuration === "all") {
                url = `/dashboard/AllLeadsCountBySource/${customerId}/${id}`
            } else {
                url = `/dashboard/LeadsCountBySourcePer_${sourceDuration}/${customerId}/${id}`
            }
            const res = await GetRequest(url, { headers }, extras)

            if (!res || res.status === false) {
                setLeadSourceData([])
                setLeadsTotalCount(0)
                return
            }

            const total = res.data.reduce(
                (acc, item) => acc + Number(item.count || 0),
                0
            )
            const filteredData = res.data.filter((item) => {
                const source = item.source?.toLowerCase().split(" ").join("_")
                return source !== "other_sources"
            })
            setLeadsTotalCount(total)
            setLeadSourceData(
                filteredData.map((c) => ({
                    name: c.source,
                    value: Number(c.count),
                    color: c.color,
                }))
            )
        } catch (error) {
            setLeadSourceData([])
            setLeadsTotalCount(0)
        }
    }
    useEffect(() => {
        handleLeadsBySource()
    }, [sourceDuration])

    return (
        <div>
            <div className="card mt-0 pt-1">
                <div className="crm-card-header pe-0 justify-content-between">
                    <span className="addEnquiryHead d-inline-block " style={{ fontWeight: 600 }}>Leads by Source</span>
                    <Dropdown as="div" className="dropdownsWithoutToggle">
                        <Dropdown.Toggle as={Nav.Link} className="header-link">
                            <button className="btn btn-icon btn-sm btn-light">
                                <FontAwesomeIcon
                                    style={{
                                        width: "15px",
                                        height: "15px",
                                    }}
                                    icon={faEllipsisVertical}
                                />
                            </button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                            className="defaultDropdown dropdown-menu-end "
                            style={{
                                width: "11rem",
                                padding: "12px 0px",
                                right: "3.4rem",
                            }}
                        >
                            <Dropdown.Item
                                href="#"
                                className="d-flex align-items-center"
                                onClick={() => setSourceDuration("all")}
                            >
                                All
                            </Dropdown.Item>
                            <Dropdown.Item
                                href="#"
                                className="d-flex align-items-center"
                                onClick={() => setSourceDuration("week")}
                            >
                                Weekly
                            </Dropdown.Item>
                            <Dropdown.Item
                                href="#"
                                className="d-flex align-items-center"
                                onClick={() => setSourceDuration("month")}
                            >
                                Monthly
                            </Dropdown.Item>
                            <Dropdown.Item
                                href="#"
                                className="d-flex align-items-center"
                                onClick={() => setSourceDuration("year")}
                            >
                                Yearly
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className=" p-0 overflow-hidden">
                    <div
                        className="crm-leads-source-chart d-flex align-items-center justify-content-center"
                        style={{ position: "relative", height: 300 }}
                    >
                        <ResponsiveContainer width="100%" height={300}>
                            <PieChart>
                                <Pie
                                    data={leadsSourceData}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={80}
                                    outerRadius={97}
                                    dataKey="value"
                                    cornerRadius={8}
                                    paddingAngle={2}
                                >
                                    {leadsSourceData !== null &&
                                        leadsSourceData?.map((entry, idx) => (
                                            <Cell key={idx} fill={entry.color} />
                                        ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                        <div
                            className="crm-lead-source-value"
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                textAlign: "center",
                            }}
                        >
                            <span className="d-block fs-14 text-muted">
                                Total
                            </span>
                            <span className="d-block fs-25 fw-bold">
                                {leadsTotalCount !== 0 ? leadsTotalCount : 0}
                            </span>
                        </div>
                    </div>
                    <div className="row row-cols-12 border-top border-block-start-dashed">
                        {leadsSourceData !== null &&
                            leadsSourceData?.map((item, idx) => (
                                <div key={idx} className="col p-0">
                                    <div
                                        className={`p-3 text-center ${idx < leadsSourceData.length - 1
                                            ? "border-end border-inline-end-dashed"
                                            : ""
                                            }`}
                                    >
                                        <div
                                            className="d-flex gap-1 align-items-center justify-content-center mb-1"
                                            style={{ gap: "0.1rem" }}
                                        >
                                            <span
                                                className="crm-dot "
                                                style={{
                                                    backgroundColor: item.color,
                                                    width: "8px",
                                                    height: "8px",
                                                    borderRadius: "50%",
                                                    display: "inline-block",
                                                }}
                                            ></span>
                                            <span
                                                className="text-muted fs-12 "
                                                title={item.name}
                                                style={{ textTransform: "capitalize" }}
                                            >
                                                {item.name?.length > 5
                                                    ? `${item.name.slice(0, 5)}...`
                                                    : item.name}
                                            </span>
                                        </div>
                                        <span> </span>
                                        <div>
                                            <span className="fs-16 fw-semibold">
                                                {item.value}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

